// **Author:** John 
import React from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Container,
  Grid,
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
} from "@mui/material";

const accounts = [
  {
    id: 1,
    name: "John Doe",
    type: "Savings",
    balance: 25000.75,
  },
  {
    id: 2,
    name: "Jane Smith",
    type: "Current",
    balance: 54200.0,
  },
  {
    id: 3,
    name: "Alex Johnson",
    type: "Salary",
    balance: 17890.5,
  },
  {
    id: 4,
    name: "Alex Johnson",
    type: "Salary",
    balance: 17890.5,
  },
];

const Accountsummary = () => {
  return (
    <section className="account">
      <Box
        sx={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #6B73FF 0%, #000DFF 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Container maxWidth="lg">
          <Paper elevation={1} sx={{ p: 2, borderRadius: 4 }}>
            <TableContainer component={Paper} sx={{ maxWidth: "lg", mx: "auto", mt: 2 }}>
              <Typography variant="h4" component="div" sx={{ p: 2, fontWeight: "bold", textAlign: "left" }}>
                Account Summary
              </Typography>
              <Table>
                <TableHead sx={{ backgroundColor: "#1976d2" }}>
                  <TableRow>
                    <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Account Holder Name</TableCell>
                    <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Account Type</TableCell>
                    <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Account Balance</TableCell>
                    <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>View</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {accounts.map((account) => (
                    <TableRow key={account.id} hover>
                      <TableCell>{account.name}</TableCell>
                      <TableCell>{account.type}</TableCell>
                      <TableCell>₹{account.balance.toLocaleString()}</TableCell>
                      <TableCell>
                        <Link to="/admin/account-details">
                          <Button variant="contained" color="primary" size="small">
                            View
                          </Button>
                        </Link>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Container>
      </Box>
    </section>
  );
};

export default Accountsummary;
